import { initializeApp } from "firebase/app"

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
  apiKey: "AIzaSyCqXseK0wFFIX9QfuPfDmS1qN-UR3n5hcM",
  authDomain: "pasartrainer-website-staging.firebaseapp.com",
  projectId: "pasartrainer-website-staging",
  storageBucket: "pasartrainer-website-staging.firebasestorage.app",
  messagingSenderId: "1042146481029",
  appId: "1:1042146481029:web:3990c4150ebee5773aeaec",
  measurementId: "G-LQ81LNGGC1",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export default app 